import styled,  { css } from 'styled-components';
import { FONTS, COLORS } from '@app/src/ui';

interface Props {
  error?: string;
}

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  border: 1px solid ${COLORS.GRAY};
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  padding: 20px;
  ${(props:Props) => props.error && css`
    border: 1px solid red;
    margin-bottom: 12px;
    span {
      color: red;
      position: absolute;
      font-size: 11px;
      left: 0;
      width: 100%;
      bottom: 0;
      transform: translateY(100%);
    }
  `}
`;

export const Textarea = styled.textarea`
  border: 0;
  margin-top: 5px;
  font-family: ${FONTS.ROBOTO};
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 22px;
  color: ${COLORS.BLACK};
  outline:none;
  resize: none;
  &::placeholder{
    color: ${COLORS.GRAY_DARK};
  }
`;

export const Title = styled.strong`
  text-transform: uppercase;
  color: ${COLORS.BLACK};
  font-size: 14px;
  font-family: ${FONTS.ROBOTO};
  font-weight: 400;
`;

export const Words = styled.div`
  display: flex;
  justify-content: space-between;
  font-family: ${FONTS.ROBOTO};
  font-style: normal;
  font-weight: normal;
  font-size: 13px;
  line-height: 16px;
  color: ${COLORS.GRAY_DARK};
  margin: 5px 0 10px 0;
`;

export const CounterWords = styled.strong`
  color: ${COLORS.BLACK};
`;